import { OptionWithAncestors } from '../models/Option';
import Customer, { ProductCode } from '../models/be/Customer';
import { Logo } from '../models/be/Branding';
import { hasValue, getVettingLogo } from '../lib/utils';
import { getBrandNameQueryStringsInLocalStorage } from './session';
import { getBranding } from './coreApi';

// not doing default export as more should be added to this file.
// eslint-disable-next-line import/prefer-default-export
export const createCustomerOptionsForPackageAvailability = (
	customer: Customer,
	ancestors: number[] = undefined
): OptionWithAncestors<number>[] => {
	let options: OptionWithAncestors<number>[] = null;
	let updatedAncestors: number[] = null;
	if (ancestors === undefined) {
		// We don't add the "root" customer to the customer tree because the current customer already has permissions.
		updatedAncestors = [customer.parentId];
		options = [];
	} else {
		const option: OptionWithAncestors<number> = {
			value: customer.customerId,
			text: customer.customerName,
			ancestors
		};
		options = [option];
		updatedAncestors = [...ancestors, customer.customerId];
	}
	return options.concat(
		customer.childCustomer
			.map((child) => {
				return createCustomerOptionsForPackageAvailability(child, updatedAncestors);
			})
			.flat()
	);
};

export const hasProfessionalSubscriptionOrHigher = (customer: Customer) => {
	if (!hasValue(customer)) {
		return false;
	}
	validateProducCode(customer.productCode);
	const { productCode } = customer;
	return (productCode && productCode === ProductCode.Professional) || productCode === ProductCode.Enterprise;
};

const validateProducCode = (productCode: ProductCode) => {
	if (productCode && !Object.values(ProductCode).includes(productCode)) {
		throw new Error(`Invalid Product Code: ${productCode}.`);
	}
};

export const getBrandingLogo = async (): Promise<Logo> => {
	const brandingName = getBrandNameQueryStringsInLocalStorage();
	if (hasValue(brandingName)) {
		try {
			const branding = await getBranding(brandingName, null);
			if (branding) {
				return branding.websiteLogo;
			}
		} catch (e) {
			return getVettingLogo();
		}
	}
	return getVettingLogo();
};

export const rootCustomerId = 14;
